import React from 'react'
import {
  ColorCards,
  ColorCard,
} from '@scentregroup/shared/hub-components/color-cards'
import { AsMeasured } from '@scentregroup/shared/hub-components/as-measured'
import {
  SGPageTemplateContentCollection,
  SGPageTemplateContentEntry,
} from '../../../../../../src/types/page-templates'
import { ModuleProps } from '../../types'

export default function SGPageTemplateContentCollectionColourCardsModule({
  module,
}: ModuleProps<SGPageTemplateContentCollection>): JSX.Element | null {
  const items = module.items.filter(
    (item): item is SGPageTemplateContentEntry =>
      item.__typename === 'SGPageTemplateContentEntry'
  )
  if (items.length === 0) {
    return null
  }
  return (
    <ColorCards title={module.title ?? undefined}>
      {items.map((item, idx) => (
        <ColorCard
          key={idx}
          {...item}
          as={props => (
            <AsMeasured
              {...props}
              metadata={item.analyticsMetadata}
              slot={module.analyticsMetadata?.displayId}
            />
          )}
        />
      ))}
    </ColorCards>
  )
}
